/* eslint-disable  */
// import { getCoreBlocks } from './core.js';

const gap = '<sep gap="36"/>';
const blockSeparator = '<sep gap="36"/>'; // At default scale, about 28px


const cdg3v2_toolbox_0 = function () {
    return `
    <category
        name="Actions"
        id="cdg3v2_action"
        colour="#F65DCE"
        secondaryColour="#E20F9C">
        <block type="cdg3v2_action_jump_to_other_lane" />
    </category>
        `

}
const cdg3v2_toolbox_1 = function () {
    return `
    <category
        name="Actions"
        id="cdg3v2_action"
        colour="#F65DCE"
        secondaryColour="#E20F9C">
        <block type="cdg3v2_action_jump_to_other_lane" />
    </category>
        `

}
const cdg3v2_toolbox_2 = function () {
    return `
    <category
        name="Actions"
        id="cdg3v2_action"
        colour="#F65DCE"
        secondaryColour="#E20F9C">
        <block type="cdg3v2_action_jump_to_other_lane" />
    </category>
        `
}
const cdg3v2_toolbox_3 = function () {
    return `
    <category
        name="Actions"
        id="cdg3v2_action"
        colour="#F65DCE"
        secondaryColour="#E20F9C">
        <block type="cdg3v2_action_switch_weapons" />
    </category>
    
        `
}
const cdg3v2_toolbox_4 = function () {
    return `
    <category
        name="Actions"
        id="cdg3v2_action"
        colour="#F65DCE"
        secondaryColour="#E20F9C">

        <block type="cdg3v2_action_jump_to_other_lane" />
        <block type="cdg3v2_action_switch_weapons" />

    </category>
        `
}
const cdg3v2_toolbox_5 = function () {
    return `
    <category
        name="Actions"
        id="cdg3v2_action"
        colour="#F65DCE"
        secondaryColour="#E20F9C">

        <block type="cdg3v2_action_jump_to_other_lane" />
        <block type="cdg3v2_action_hover" />
        <block type="cdg3v2_action_drop" />
    </category>
    
        `
}
const cdg3v2_toolbox_6 = function () {
    return `
    <category
        name="Actions"
        id="cdg3v2_action"
        colour="#F65DCE"
        secondaryColour="#E20F9C">

        <block type="cdg3v2_action_jump_to_other_lane" />
        <block type="cdg3v2_action_switch_weapons" />
        <block type="cdg3v2_action_hover" />
        <block type="cdg3v2_action_drop" />

    </category>
        `
}
const cdg2_action_blocks = function () {
    return `

    <category
    name="Actions"
    id="cdg3v2_action"
    colour="#F65DCE"
    secondaryColour="#E20F9C">
      <block type="cdg3v2_action_jump_to_other_lane" />
      <block type="cdg3v2_action_switch_weapons" />
      <block type="cdg3v2_action_hover" />
      <block type="cdg3v2_action_drop" />
    <block type="cdg3v2_action_change_lane" />
  </category>


    

  `
}
const cdg2_control_blocks = function () {
    return `
  <category name="%{BKY_CATEGORY_CONTROL}" id="control" colour="#FFAB19" secondaryColour="#CF8B17">
    <block type="control_if"/>
    <block type="control_if_else"/>
    <block id="wait_until" type="control_wait_until"/>
  </category>
  `
}
const cdg2_operators_blocks = function () {

    return `
<category name="%{BKY_CATEGORY_OPERATORS}" id="operators" colour="#40BF4A" secondaryColour="#389438">
<block type="operator_add">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
      <block type="operator_subtract">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
      <block type="operator_multiply">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
      <block type="operator_divide">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
  <block type="operator_gt">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
<block type="operator_lt">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
<block type="operator_equals">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
${blockSeparator}
<block type="operator_and"/>
<block type="operator_or"/>
<block type="operator_not"/>
${blockSeparator}
</category>`

}
const xmlOpen = '<xml style="display: none">';
const xmlClose = "</xml>";
const makeCDG3v2ToolboxXML = () => {

    // const coreCategories = getCoreBlocks();
    return [
        xmlOpen,
        // gap,
        // cdg2_event_blocks(),
        gap,
        cdg2_action_blocks(),
        // gap,
        // cdg2_sensing_blocks(),
        // gap,
        //cdg2_control_blocks(),
        //gap,
        //cdg2_operators_blocks(),
        // gap,
        xmlClose
    ].join("\n");
}

const getToolboxes = () => {
    const toolbox0 = [
        xmlOpen,
        // gap,
        // cdg2_event_blocks(),
        gap,
        cdg3v2_toolbox_0(),
        // gap,
        // cdg2_sensing_blocks(),
        // gap,
        //cdg2_control_blocks(),
        //gap,
        //cdg2_operators_blocks(),
        // gap,
        xmlClose
    ].join("\n");
    const toolbox1 = [
        xmlOpen,
        // gap,
        // cdg2_event_blocks(),
        gap,
        cdg3v2_toolbox_1(),
        // gap,
        // cdg2_sensing_blocks(),
        // gap,
        //cdg2_control_blocks(),
        //gap,
        //cdg2_operators_blocks(),
        // gap,
        xmlClose
    ].join("\n");
    const toolbox2 = [
        xmlOpen,
        // gap,
        // cdg2_event_blocks(),
        gap,
        cdg3v2_toolbox_2(),
        // gap,
        // cdg2_sensing_blocks(),
        // gap,
        //cdg2_control_blocks(),
        //gap,
        //cdg2_operators_blocks(),
        // gap,
        xmlClose
    ].join("\n");
    const toolbox3 = [
        xmlOpen,
        // gap,
        // cdg2_event_blocks(),
        gap,
        cdg3v2_toolbox_3(),
        // gap,
        // cdg2_sensing_blocks(),
        // gap,
        //cdg2_control_blocks(),
        //gap,
        //cdg2_operators_blocks(),
        // gap,
        xmlClose
    ].join("\n");
    const toolbox4 = [
        xmlOpen,
        // gap,
        // cdg2_event_blocks(),
        gap,
        cdg3v2_toolbox_4(),
        // gap,
        // cdg2_sensing_blocks(),
        // gap,
        //cdg2_control_blocks(),
        //gap,
        //cdg2_operators_blocks(),
        // gap,
        xmlClose
    ].join("\n");
    const toolbox5 = [
        xmlOpen,
        // gap,
        // cdg2_event_blocks(),
        gap,
        cdg3v2_toolbox_5(),
        // gap,
        // cdg2_sensing_blocks(),
        // gap,
        //cdg2_control_blocks(),
        //gap,
        //cdg2_operators_blocks(),
        // gap,
        xmlClose
    ].join("\n");
    const toolbox6 = [
        xmlOpen,
        // gap,
        // cdg2_event_blocks(),
        gap,
        cdg3v2_toolbox_6(),
        // gap,
        // cdg2_sensing_blocks(),
        // gap,
        //cdg2_control_blocks(),
        //gap,
        //cdg2_operators_blocks(),
        // gap,
        xmlClose
    ].join("\n");

    return [toolbox0, toolbox1, toolbox2, toolbox3, toolbox4, toolbox5, toolbox6];
}

export { makeCDG3v2ToolboxXML, getToolboxes };